module.exports = __webpack_public_path__ + "bef97940b0e2cfdf93579ec1e04bc030.pdf";